import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    invitationId: Number,
    baseUrl: { type: String, default: "/psychologists/invites" }
  }

  open(event) {
    const modal = document.getElementById("decline-modal")
    if (!modal) return

    const invitationId = event.currentTarget.dataset.declineModalInvitationIdValue
    const baseUrl = event.currentTarget.dataset.declineModalBaseUrlValue || this.baseUrlValue

    modal.classList.remove("hidden")

    const form = modal.querySelector("[data-decline-modal-target='form']")
    if (form) {
      form.action = `${baseUrl}/${invitationId}/decline`
    }
  }

  close() {
    const modal = document.getElementById("decline-modal")
    if (!modal) return

    modal.classList.add("hidden")

    const reasonInput = modal.querySelector("[data-decline-modal-target='reason']")
    if (reasonInput) {
      reasonInput.value = ""
    }
  }

  submit(event) {
    const modal = document.getElementById("decline-modal")
    if (!modal) return

    const reasonInput = modal.querySelector("[data-decline-modal-target='reason']")
    const hiddenInput = modal.querySelector("[data-decline-modal-target='hiddenReason']")

    if (reasonInput && hiddenInput) {
      hiddenInput.value = reasonInput.value
    }
  }
}
